import { AbstractOperator } from './AbstractOperator';
export class EqualBlock extends AbstractOperator {
  getCalculatorCode(): string {
    return '==';
  }

  getCalculatorField(): string {
    return ' = ';
  }
}
